import { resolveApiUrl } from '@/lib/api/client';

/**
 * Absolutize a row's `avatarUrl` against the API base.
 *
 * List rows stopped carrying inlined base64 photos when the payload was trimmed: the server now
 * emits an API-RELATIVE, self-authenticating path (`/api/users/{id}/avatar?v=…&t=…`, or its group
 * twin `/api/threads/{id}/avatar?…`). The renderer is NEVER same-origin with the API — file://
 * when packaged, the Vite origin in dev, and there is no proxy — so an <img> handed the raw path
 * loads nothing and the row silently falls back to its initials, which is indistinguishable from
 * "this person has no photo". Resolving at the API boundary keeps every consumer (list rows,
 * conversation header, member panel, tasks, board cards, search results) on one rule.
 *
 * Rows without an avatar are returned untouched, so a row's identity changes only when its avatar
 * actually needed rewriting.
 */
export function withResolvedAvatarUrl(row) {
  if (!row || typeof row !== 'object' || !row.avatarUrl) return row;
  const resolved = resolveApiUrl(row.avatarUrl);
  return resolved === row.avatarUrl ? row : { ...row, avatarUrl: resolved };
}

/** Array form of withResolvedAvatarUrl. A non-array (absent section) becomes []. */
export function withResolvedAvatarUrls(rows) {
  return Array.isArray(rows) ? rows.map(withResolvedAvatarUrl) : [];
}
